enum EmploymentType {
  CONTRACT = "Contract",
  CONTRACTOR = "Contractor",
  FULL_TIME_CONTRACT = "Contract to Full Time",
  FLEXIBLE = "Flexible",
}

export default EmploymentType;
